import { graphql } from "../__generated__";

export const MUTATION_AUTH_RESET_PASSWORD = graphql(`
  mutation resetPassword($email: String!) {
    resetPassword(email: $email)
  }
`);
